// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3GVd4","approved":"Status_approved__ZV0Do","rejected":"Status_rejected__2J7z5","expired":"Status_expired__pNSq7","label":"Status_label__yh8Me"};